import React from 'react'
import { HBB_QUALIFICATION_PURCHASE_AMOUNT } from 'shared/constants'
import Link from 'components/link'

export const HBBRestrictionsMessage = ({ className }) => (
  <small className={className}>
    *With minimum of ${HBB_QUALIFICATION_PURCHASE_AMOUNT} Babylist shop
    purchase. Shipping and handling not included. Some{' '}
    <Link
      newWindow
      url="https://help.babylist.com/hc/en-us/articles/360054057353-How-do-I-get-a-Hello-Baby-Box-"
    >
      restrictions apply
    </Link>
    .
  </small>
)
